<h1 mat-dialog-title>Success</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button class="btn create-ac-btn btn-lg btn-block" (click)="onNoClick()">Ok</button>
  
</div>
